// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"78b72723","319":"6d1fd57f","429":"8608fb8c","457":"724a6f31","484":"38d48ca7","527":"68936735","551":"66dca899","828":"3464384d","842":"c1bb0bea","851":"853ed5f3","910":"1df2c2d2"}[chunkId] + ".chunk.js";
};